export const textFields = [
  'text', 'password', 'hidden',
];

export const fieldHasLabel = [
  'text', 'password', 'hidden', 'select', 'checkboxGroup','percentage','currency'
];
